module.exports = __webpack_public_path__ + "media/images/game/categories/vanoce-d19e783f570887176142ac3f2016037c.png";